import { Component, Inject, Input, OnInit } from '@angular/core';
import { combineLatest, Observable, of } from 'rxjs';
import { map, switchMap, finalize, catchError } from 'rxjs/operators';
import { Post, TheLoopService } from '@vendasta/the-loop';
import { IAMService, User } from '@vendasta/iam';
import { SessionService } from '@galaxy/core';

@Component({
  selector: 'sales-common-loop-v2-post-content',
  templateUrl: './post-content.component.html',
  styleUrls: ['./post-content.component.scss'],
  providers: [],
})
export class PostContentComponent implements OnInit {
  @Input() postId = '';
  @Input() typeId = '';

  post$: Observable<Post>;
  user$: Observable<User>;

  loading: boolean;

  constructor(
    private readonly service: TheLoopService,
    @Inject('partnerId$') private readonly partnerId$: Observable<string>,
    private readonly iam: IAMService,
    private sessionService: SessionService,
  ) {}

  ngOnInit(): void {
    this.user$ = combineLatest([this.partnerId$, this.sessionService.getSessionId()]).pipe(
      switchMap(([partnerId, session]) => {
        return this.iam.getMultiUsers([
          {
            namespacedSession: {
              namespace: partnerId,
              session: session,
            },
          },
        ]);
      }),
      map((userIds) => {
        return userIds[0];
      }),
    );

    this.loading = true;
    this.post$ = this.service.getPost(this.typeId, this.postId).pipe(
      catchError((err) => {
        console.error(err);
        return of(null);
      }),
      finalize(() => {
        this.loading = false;
      }),
    );
  }
}
